import React, { createContext, useReducer, useCallback } from "react";
import axios from "axios";
import BlogReducer from "./BlogReducer";

export const BlogContext = createContext();
const BlogContextProvider = (props) => {
  const [post, dispatch] = useReducer(BlogReducer, {
    blogpost: [],
    categorylist: null,
    singlepost: null,
    popularpost: [],
    categorypost: [],
    currentPath: "",
    images: [],
    loading: false,
    categotyloading: false,
    popularpostloading: false,
    error: false,
    categoryerror: false,
    popularposterror: false,
  });
  const getBlogPost = useCallback((category, loadmore) => {
    dispatch({ type: "POST_LOADING" });
    axios
      .get(process.env.REACT_APP_SERVER_URL + "/post/blogpost", {
        params: {
          category,
          loadmore,
        },
      })
      .then((res) => {
        dispatch({
          type: "GET_POST",
          blogpost: { data: res.data, path: category },
        });
      })
      .catch((err) => {
        dispatch({ type: "POST_ERROR", error: err.response.data });
      });
  }, []);
  const getPopularPost = useCallback(() => {
    dispatch({ type: "POPULARPOST_LOADING" });
    axios
      .get(process.env.REACT_APP_SERVER_URL + "/post/popularblog")
      .then((res) => {
        dispatch({ type: "GET_POPULARPOST", popularpost: res.data });
      })
      .catch((err) => {
        dispatch({
          type: "POPULARPOST_ERROR",
          popularerror: err.response.data,
        });
      });
  }, []);
  const getCategoryList = useCallback(() => {
    dispatch({ type: "CATEGORY_LOADING" });
    axios
      .get(process.env.REACT_APP_SERVER_URL + "/post/categorylist")
      .then((res) => {
        dispatch({ type: "GET_CATEGORY", categorylist: res.data });
      })
      .catch((err) => {
        dispatch({ type: "CATEGORY_ERROR", categoryerror: err.response.data });
      });
  }, []);
  const getSingleBlog = useCallback((postid) => {
    dispatch({ type: "POST_LOADING" });
    axios
      .get(process.env.REACT_APP_SERVER_URL + "/post/singleblog/" + postid)
      .then((res) => {
        dispatch({ type: "GET_SINGLEPOST", singlepost: res.data });
      })
      .catch((err) => {
        dispatch({ type: "POST_ERROR", error: err.response.data });
      });
  }, []);
  const getImages = useCallback((loadmore) => {
    dispatch({ type: "POST_LOADING" });
    axios
      .get(process.env.REACT_APP_SERVER_URL + "/post/blogimages", {
        params: {
          loadmore,
        },
      })
      .then((res) => {
        dispatch({ type: "GET_IMAGES", images: res.data });
      })
      .catch((err) => {
        dispatch({
          type: "POST_ERROR",
          error: err.response.data || { defaultError: "Something went wrong" },
        });
      });
  }, []);

  return (
    <BlogContext.Provider
      value={{
        post,
        getImages,
        getBlogPost,
        getSingleBlog,
        getCategoryList,
        getPopularPost,
      }}
    >
      {props.children}
    </BlogContext.Provider>
  );
};

export default BlogContextProvider;
